import { openPanel } from './plp-store_selection-finder';

export function updateFilterZoneState() {

  const storeFilter = cube.$('.store-filter');
  const filterableClass = 'store-filter--filterable';
  const nonFilterableClass = 'store-filter--non-filterable';
  const locationInviteClass = 'store-filter--location-invite';

  const storeFilterDatas = cube.$('.store-filter-data').dataset;

  const storeNameTitle = storeFilterDatas.storeName.trim();
  const storeFilterAvailability = storeFilterDatas.storeFilterAvailability.trim();

  // reset store classes
  storeFilter.classList.remove(filterableClass);
  storeFilter.classList.remove(nonFilterableClass);
  storeFilter.classList.remove(locationInviteClass);

  // If there is already a store :
  if (storeNameTitle !== 'noStore') {
    let displayStoreName;
    if (storeNameTitle !== 'defaultStoreName') {
      displayStoreName = storeNameTitle;
    } else {
      displayStoreName = window.Messages(
        'product.stock.store.defaultStoreName'
      );
    }
    cube.$$('.store-filter__store-name').forEach(nameHolder => {
      const el = nameHolder;
      el.innerHTML = `"${displayStoreName}"`;
    });

    if (storeFilterAvailability === 'true') {
      storeFilter.classList.add(filterableClass);
      initFilterState();
    } else storeFilter.classList.add(nonFilterableClass);
  } else {
    storeFilter.classList.add(locationInviteClass);
  }
}

function initStoreFilterState() {

  if(cube.$id('product-filters-ajax-reload').dataset.store && cube.$id('product-filters-ajax-reload').dataset.store === 'true') {

    cube.$('.store-filter').classList.add('store-filter--visible');
    cube.$('#resultslist-page-products').classList.remove('hidden-store-feature');

  }
}

export function initFilterState() {
  // define check or uncheck status

  const filterState = cube.$('.store-filter-data').dataset.filterState.trim();

  if (filterState) {
    const filterCheckbox = cube.$id('store-filter__toggle');

    if (filterState === 'true') filterCheckbox.checked = true;
    else filterCheckbox.checked = false;
  }
}

export function init() {
  updateFilterZoneState();
  initStoreFilterState();

  cube.$id('main-container').on('click', event => {
    if (event.target.classList.contains('.js-open-store-selector') ||
      event.target.closest('.js-open-store-selector')) {
      openPanel();
    }
  });

  cube.event.on('listPageElementsRefresh', () => {
    initStoreFilterState();
    updateFilterZoneState();
  });
}



// WEBPACK FOOTER //
// ./src/catalog/product-list/store_filter.entry.js